import { render, staticRenderFns } from "./ExamManagementContent.vue?vue&type=template&id=7b2c03c2&scoped=true"
var script = {}
import style0 from "./ExamManagementContent.vue?vue&type=style&index=0&id=7b2c03c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b2c03c2",
  null
  
)

export default component.exports